/**
 * @file Pipe used for capitalizing a string
 * @author Heino Lenting
 */
import { PipeTransform } from '@angular/core';
/**
 * The class for capitalize functionality
 */
var CapitalizePipe = /** @class */ (function () {
    function CapitalizePipe() {
    }
    /**
     * Returns the string parameter with the first character capitalized
     * @param {*} value The string to be capitalized
     * @param {*} [restLower=false] The rest of the string is in lower case if the parameter is true
     * @returns A capitalized string
     */
    CapitalizePipe.prototype.transform = function (value, restLower) {
        if (restLower === void 0) { restLower = false; }
        if (value) {
            return value.charAt(0).toUpperCase() + (restLower ? value.toLowerCase() : value).slice(1);
        }
        return value;
    };
    return CapitalizePipe;
}());
export { CapitalizePipe };
